import Image from 'next/image'

import { useSvgUrl } from '@/hooks/useSvgUrl'

interface Props {
  svg: string | undefined | null
  width?: number
  height?: number
  className?: string
}

export const ImgSVGUrl: React.FC<Props> = ({
  svg,
  width = 120,
  height = 120,
  className,
}) => {
  const url = useSvgUrl(svg)

  if (!url) return null

  return (
    <Image
      src={url}
      width={width}
      height={height}
      className={className}
      alt=""
    />
  )
}
